function LA_INIT() {
  // eslint-disable-next-line no-undef
  lh('init', {provider: process.env.VUE_APP_LISTHUB_KEY, test: process.env.VUE_APP_LISTHUB_TEST});
}

function LA_DETAIL_PAGE_VIEWED(listingKey) {
  // eslint-disable-next-line no-undef
  lh('submit', 'DETAIL_PAGE_VIEWED', {lkey: listingKey});
}

function LA_SEARCH_DISPLAY(keysArray) {
  let listingsKeys = [];
  keysArray.forEach (keyItem => {
    listingsKeys.push({
      lkey: keyItem
    })
  });
  // eslint-disable-next-line no-undef
  lh('submit', 'SEARCH_DISPLAY', listingsKeys);
}

function LA_AGENT_EMAIL_SENT(listingKey) {
  // eslint-disable-next-line no-undef
  lh('submit', 'AGENT_EMAIL_SENT', {lkey: listingKey});
}

export {
  LA_INIT,
  LA_DETAIL_PAGE_VIEWED,
  LA_SEARCH_DISPLAY,
  LA_AGENT_EMAIL_SENT,
}